import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchAdminDashboard } from "./thunks";

interface RecentEstablishment {
  id: number;
  name: string;
  email: string;
  created_at: string;
}

interface EstablishmentsByPlan {
  plan_id: number;
  count: number;
  plan: {
    id: number;
    name: string;
    price: string;
  };
}

interface AdminDashboardData {
  total_establishments: number;
  active_establishments: number;
  inactive_establishments: number;
  total_users: number;
  total_owners: number;
  recent_establishments: RecentEstablishment[];
  establishments_by_plan: EstablishmentsByPlan[];
}

interface AdminDashboardState {
  data: AdminDashboardData | null;
  loading: boolean;
  error: string | null;
}

// Dados mock para desenvolvimento
const mockData: AdminDashboardData = {
  total_establishments: 25,
  active_establishments: 22,
  inactive_establishments: 3,
  total_users: 156,
  total_owners: 25,
  recent_establishments: [
    {
      id: 5,
      name: "Salão Beleza Pura",
      email: "contato@belezapura.com",
      created_at: "2025-09-26T10:30:00.000000Z",
    },
    {
      id: 6,
      name: "Barbearia Moderna",
      email: "contato@barberiamoderna.com",
      created_at: "2025-09-25T15:20:00.000000Z",
    },
    {
      id: 7,
      name: "Studio de Beleza",
      email: "contato@studiobeleza.com",
      created_at: "2025-09-24T09:45:00.000000Z",
    },
  ],
  establishments_by_plan: [
    {
      plan_id: 1,
      count: 15,
      plan: {
        id: 1,
        name: "Plano Básico",
        price: "29.90",
      },
    },
    {
      plan_id: 2,
      count: 10,
      plan: {
        id: 2,
        name: "Plano Premium",
        price: "59.90",
      },
    },
  ],
};

const initialState: AdminDashboardState = {
  data: mockData, // Usar dados mock inicialmente para desenvolvimento
  loading: false,
  error: null,
};

const adminDashboardSlice = createSlice({
  name: "adminDashboard",
  initialState,
  reducers: {
    clearAdminDashboard: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchAdminDashboard.fulfilled,
        (state, action: PayloadAction<AdminDashboardData>) => {
          state.loading = false;
          state.data = action.payload;
        },
      )
      .addCase(fetchAdminDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as { error: string })?.error || "Erro desconhecido";
      });
  },
});

export const { clearAdminDashboard } = adminDashboardSlice.actions;
export default adminDashboardSlice.reducer;
